import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37abb566&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=37abb566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37abb566",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37abb566')) {
      api.createRecord('37abb566', component.options)
    } else {
      api.reload('37abb566', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=37abb566&scoped=true&", function () {
      api.rerender('37abb566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templatesFrom/index.vue"
export default component.exports